import { Component, OnInit } from '@angular/core';
import { ToastService } from '../../services/toaster/toaster.service';
import { ToastMessage } from '../../models/internal/toastmessage';
import UIHelper from 'src/app/core/utility/ui-helper';
@Component({
  selector: 'app-toast',
  templateUrl: './toaster-notification.component.html',
  styleUrls: ['./toaster-notification.component.scss']
})
export class ToastComponent implements OnInit {
  toasts: ToastMessage[] = [];

  constructor(private toastService: ToastService) { }

  ngOnInit(): void {
    this.toastService.getToast().subscribe((toast: ToastMessage) => {
      if (!toast) {
        // clear toasts when an empty toast is received
        this.toasts = []; 
        return;
      }
      this.toasts.push(toast);
      UIHelper.ScrollToTopForDivContent();
      /*
      TMS-17416 Commenting timeout function so that user can close error/success message using
      X button other than disappering message automatically after 5000 ms
      */
   /* if(!toast.keepAfterRouteChange)
      {
      setTimeout(() => this.removeToast(toast), Constants.NOTIFY_DURATION);
      }  */
    });
  }

  isSingleLine(message: string): boolean {
    return message.indexOf("|") ==-1;
  }

  removeToast(toast: ToastMessage): void {
    this.toasts = this.toasts.filter(x => x !== toast);
  }
}